export const QUICK_LIST_PRODUCT_CUSTOM_LIST_TYPE_ID =
  '8277F210-DAA8-11EC-9D64-0242AC120002'

export const QUICK_LIST_PAGE_SIZE_OPTIONS = [10, 20, 30, 50]

export const QUICK_LIST_STATUS_OPTIONS = [
  { value: true, label: 'QUICK_LIST_SETTINGS.FORM.ACTIVE' },
  { value: false, label: 'QUICK_LIST_SETTINGS.FORM.INACTIVE' },
]

export const QUICK_LIST_ROUTES = {
  CREATE: '/settings/quicklist/information',
  EDIT: id => `/settings/quicklist/information/${id}`,
}
